import { useState } from 'react';
import { rankingFilms } from '@/mocks/home';
import SectionHeading from './SectionHeading';

const tabs = [
  { key: 'all', label: '总榜' },
  { key: '校园片', label: '校园片' },
  { key: '初恋电影', label: '初恋电影' },
  { key: '治愈系', label: '治愈系' },
];

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'up') return <i className="ri-arrow-up-line text-primary-600" />;
  if (trend === 'down') return <i className="ri-arrow-down-line text-accent-600" />;
  return <i className="ri-subtract-line text-foreground-400" />;
}

export default function RankingSection() {
  const [tab, setTab] = useState('all');
  const list = tab === 'all' ? rankingFilms : rankingFilms.filter((f) => f.genre === tab);

  return (
    <section id="ranking" className="scroll-mt-24 bg-secondary-50 py-10 md:py-14 border-y border-secondary-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="WEEKLY CHART"
          title="本周热看榜"
          desc="按影迷真实观看与短评热度实时滚动，追片不踩雷。"
        />

        <div className="inline-flex items-center gap-1 bg-background-50 border border-secondary-200 rounded-full p-1 mb-6">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                tab === t.key
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:text-primary-700'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="bg-background-50 border border-secondary-200 rounded-lg overflow-hidden">
          {list.map((film, idx) => (
            <a
              key={film.id}
              href="#library"
              className="flex items-center gap-4 px-4 md:px-5 py-3.5 border-b border-secondary-100 last:border-b-0 hover:bg-primary-50/60 transition-colors"
            >
              <span
                className={`shrink-0 w-8 h-8 rounded-md flex items-center justify-center text-sm font-bold ${
                  idx < 3
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 border border-background-200'
                }`}
              >
                {film.rank}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {film.title}
                  </h3>
                  <span className="hidden sm:inline text-[11px] text-secondary-900 bg-secondary-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {film.genre}
                  </span>
                </div>
              </div>
              <div className="hidden md:flex items-center gap-5 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1 w-16">
                  <i className="ri-heart-line text-accent-500" />
                  {film.likes}
                </span>
                <span className="inline-flex items-center gap-1 w-16">
                  <i className="ri-chat-3-line" />
                  {film.comments}
                </span>
              </div>
              <div className="shrink-0 flex items-center gap-2 w-16 justify-end">
                <span className="text-sm font-bold text-primary-700">{film.score}</span>
                <TrendIcon trend={film.trend} />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}